var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1442_48039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.8333C12.0389 10.8333 11.6667 11.2067 11.6667 11.6667V15C11.6667 15.4589 11.2933 15.8333 10.8333 15.8333H8.33333V3.33333C8.33333 2.62111 7.88 1.98556 7.19889 1.74889L6.95222 1.66667H10.8333C11.2933 1.66667 11.6667 2.04111 11.6667 2.5V5C11.6667 5.46 12.0389 5.83333 12.5 5.83333C12.9611 5.83333 13.3333 5.46 13.3333 5V2.5C13.3333 1.12111 12.2111 0 10.8333 0H1.87556C1.84333 0 1.81667 0.0144444 1.78667 0.0177778C1.74556 0.0144444 1.70778 0 1.66667 0C0.747778 0 0 0.747778 0 1.66667V16.6667C0 17.3789 0.453333 18.0144 1.13444 18.2511L6.15 19.9233C6.32 19.9744 6.48889 20 6.66667 20C7.58556 20 8.33333 19.2522 8.33333 18.3333V17.5H10.8333C12.2122 17.5 13.3333 16.3778 13.3333 15V11.6667C13.3333 11.2067 12.9611 10.8333 12.5 10.8333Z",
    fill: "#8E99A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7557 7.74443L16.4224 4.41109C16.1846 4.17221 15.8257 4.10109 15.5135 4.22998C15.2035 4.35887 15.0002 4.66332 15.0002 4.99998V7.49998H11.6668C11.2068 7.49998 10.8335 7.87332 10.8335 8.33332C10.8335 8.79332 11.2068 9.16665 11.6668 9.16665H15.0002V11.6666C15.0002 12.0033 15.2035 12.3078 15.5146 12.4366C15.8268 12.5655 16.1846 12.4944 16.4235 12.2555L19.7568 8.92221C20.0813 8.59665 20.0813 8.06998 19.7557 7.74443Z",
    fill: "#8E99A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1442_48039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.6b5938bc2107c8be6abee2a29424c3da.svg";
export { ForwardRef as ReactComponent };